import {
  createStyles,
  Grid,
  IconButton,
  makeStyles,
  MenuItem,
  Select,
  Theme,
} from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { getMonth, getYear, setMonth, setYear } from 'date-fns';
import React, { useMemo } from 'react';

interface Props {
  date: Date;
  setDate: (date: Date) => void;
  minDate: Date;
  maxDate: Date;
  nextDisabled: boolean;
  prevDisabled: boolean;
  onClickNext: () => void;
  onClickPrevious: () => void;
}

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

const generateYearsRange = (minDate: Date, maxDate: Date) => {
  const minYear = minDate.getFullYear();
  const maxYear = maxDate.getFullYear();

  return Array(maxYear - minYear + 1)
    .fill('')
    .map((_, idx) => minYear + idx);
};

const CalendarPickerHeader: React.FC<Props> = ({
  date,
  setDate,
  minDate,
  maxDate,
  nextDisabled,
  prevDisabled,
  onClickNext,
  onClickPrevious,
}) => {
  const classes = useStyles();
  const years = useMemo(() => {
    return generateYearsRange(minDate, maxDate);
  }, [minDate, maxDate]);

  const handleMonthChange = (event: any) => {
    setDate(setMonth(date, parseInt(event.target.value, 10)));
  };

  const handleYearChange = (event: any) => {
    setDate(setYear(date, parseInt(event.target.value, 10)));
  };

  return (
    <Grid container justify="space-between" alignItems="center">
      <Grid item className={classes.iconContainer}>
        <IconButton className={classes.icon} disabled={prevDisabled} onClick={onClickPrevious}>
          <ChevronLeft color={prevDisabled ? 'disabled' : 'action'} />
        </IconButton>
      </Grid>
      <Grid item>
        <Select value={getMonth(date)} onChange={handleMonthChange} className={classes.select}>
          {MONTHS.map((month, idx) => (
            <MenuItem key={month} value={idx}>
              {month}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid item>
        <Select value={getYear(date)} onChange={handleYearChange} className={classes.select}>
          {years.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid item className={classes.iconContainer}>
        <IconButton className={classes.icon} disabled={nextDisabled} onClick={onClickNext}>
          <ChevronRight color={nextDisabled ? 'disabled' : 'action'} />
        </IconButton>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    select: {
      padding: theme.spacing(4),
    },
    iconContainer: {
      padding: 5,
    },
    icon: {
      padding: 10,
      '&:hover': {
        background: 'none',
      },
    },
  }),
);

export default CalendarPickerHeader;
